export default "__VITE_ASSET__iNCfHAWd__"